import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaDataUltimoAcesso = (): TabelaColuna => ({
  Chave: 'DataUltimoAcessoPortal',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.dataLocaleString(linha.DataUltimoAcessoPortal)}</span>
  ),
  RenderizarCabecalho: () => (
    <div style={{ width: 90 }}>Data Ultimo Acesso Portal</div>
  )
})
